export interface OrderProductOption {
  optionValueID: string;
  optionValueName: string;
}

export const orderProductOptionFromResponse = (
  responseData: any,
): OrderProductOption => ({
  optionValueID: responseData.key,
  optionValueName: responseData.value,
});
